// extracted by mini-css-extract-plugin
module.exports = {"pin":"pin--1aKXt","icon":"icon--1ApCH","hovered":"hovered--vX3uP","rate":"rate--2cqHX"};